// extracted by mini-css-extract-plugin
module.exports = {"help-center-chat-widget--container":"help-center-chat-widget_help-center-chat-widget--container___ErNX"};